module.exports = __webpack_public_path__ + "static/media/logout.993758c0.svg";